import React, { FC, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { ConfigurationType, ConfigurationUpdateRequest, ConfigurationView } from '../../shared/types/configuration';
import { updateConfigurationFetch } from '../../app/axios/configurationFetches';
import HLFormInput from '../../shared/components/input/HLFormInput';
import HLButton, { HLButtonStyleType } from '../../shared/components/button/HLButton';
import HLErrorMessage from '../../shared/components/error-message/HLErrorMessage';
import HLModal from '../../shared/components/modal/HLModal';
import { processFormServerError } from '../../shared/utils/processFormServerError';
import { HLCheckbox } from '../../shared/components/checkbox/HLCheckbox';

interface UpdateConfigurationModalProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  configuration: ConfigurationView | null;
  onSuccess: () => void;
}

const UpdateConfigurationModal: FC<UpdateConfigurationModalProps> = ({
                                                                       open,
                                                                       setOpen,
                                                                       configuration,
                                                                       onSuccess
                                                                     }) => {
  const {
    register,
    handleSubmit,
    reset,
    setError,
    setValue,
    watch,
    formState: { errors, isSubmitting }
  } = useForm<ConfigurationUpdateRequest>()
  
  useEffect(() => {
    if (open) reset()
    
    if (open && configuration) {
      setValue('value', configuration.value)
    }
  }, [configuration, open, setValue])
  
  const updateConfiguration = async (request: ConfigurationUpdateRequest) => {
    if (!configuration) return
    
    try {
      await updateConfigurationFetch(configuration.id, { value: request.value })
      closeModal()
      onSuccess()
    } catch (err: any) {
      processFormServerError(err, setError)
    }
  }
  
  const closeModal = () => {
    reset()
    setOpen(false)
  }
  
  if (!configuration) return null
  
  const renderValueInput = () => {
    switch (configuration.type) {
      case ConfigurationType.BOOLEAN:
        return (
          <HLCheckbox
            id="value"
            {...register('value')}
          >
            Включено
          </HLCheckbox>
        )
      case ConfigurationType.NUMBER:
        return (
          <HLFormInput
            id="value"
            type="number"
            step="1"
            {...register('value')}
            placeholder="Значение"
            error={errors.value?.message}
          />
        )
      default:
        return (
          <HLFormInput
            id="value"
            {...register('value')}
            placeholder="Значение"
            error={errors.value?.message}
          />
        )
    }
  }
  
  return (
    <HLModal open={open} onClose={closeModal} title="Изменить конфигурацию">
      <form onSubmit={handleSubmit(updateConfiguration)} className="columnContainer">
        <HLErrorMessage error={errors.root?.message}/>
        
        <p>{configuration.description}</p>
        
        {renderValueInput()}
        
        <div className="inlineContainer">
          <HLButton
            type="submit"
            disabled={isSubmitting}
          >
            Изменить
          </HLButton>
          <HLButton
            type="button"
            onClick={closeModal}
            styleType={HLButtonStyleType.GRAY}
          >
            Отмена
          </HLButton>
        </div>
      </form>
    </HLModal>
  )
}

export default UpdateConfigurationModal
